import React from 'react';
import { useTranslation } from 'react-i18next';
import Stack from 'components/Stack';
import TitleCard from 'components/TitleCard';
import { DefaultFormFieldLayout } from 'components/FormField';
import { ShareableLinkField, ShareNowField } from 'components/FormFields';
import NudgesOverviewCard from 'components/NudgesOverviewCard';
import FormStack from 'components/FormStack';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function AssetSharePage(_ref) {
  var id = _ref.id,
    playlistId = _ref.playlistId,
    shareData = _ref.shareData;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/_jsxs(Stack, {
    spacing: "m",
    children: [shareData && /*#__PURE__*/_jsx(TitleCard, {
      title: t('actions_share_now'),
      variant: "raised",
      children: /*#__PURE__*/_jsx(DefaultFormFieldLayout, {
        horizontal: true,
        children: /*#__PURE__*/_jsxs(FormStack, {
          spacing: "m",
          children: [/*#__PURE__*/_jsx(ShareNowField, {
            shareData: shareData
          }), /*#__PURE__*/_jsx(ShareableLinkField, {
            contentId: id,
            parentPlaylistId: playlistId
          })]
        })
      })
    }), /*#__PURE__*/_jsx(NudgesOverviewCard, {
      contentId: id,
      type: "asset",
      variant: "raised"
    })]
  });
}
export default AssetSharePage;